import gql from 'graphql-tag'

export const mudarLinguaUsuario = gql`
  mutation SalvarUsuarioLogadoMutation($id: ID!, $idioma: Idioma!) {
    mudarLinguaUsuario(id: $id, idioma: $idioma) {
      id
      nome
      idioma {
        id
      }
    }
  }
`
